export default __webpack_public_path__ + "static/media/icon_cb_16.39adec14.png";